import React, { useEffect, useState } from 'react';
import { FaEye, FaEdit, FaTrash, FaPlus, FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import PaymentTermsFormModal from './DeliveryTermFormModal';
import PaymentTermsViewModal from './PaymentTermViewModal';
import Sidebar from './Sidebar';

const API_URL = '/api';

const PaymentTermsMaster = () => {
  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showView, setShowView] = useState(false);
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  useEffect(() => { fetchTerms(); }, []);

  const fetchTerms = async () => {
  setLoading(true);
  try {
    const res = await fetch(`${API_URL}/payment-terms`);
    const data = await res.json();

    // ✅ always set an array
    if (Array.isArray(data)) {
      setTerms(data);
    } else if (Array.isArray(data.data)) {
      setTerms(data.data);
    } else {
      setTerms([]);
    }
  } catch {
    setTerms([]);
  }
  setLoading(false);
};


  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
    const sorted = [...terms].sort((a, b) => {
      if (!a[key]) return 1;
      if (!b[key]) return -1;
      return direction === 'asc'
        ? a[key].localeCompare(b[key])
        : b[key].localeCompare(a[key]);
    });
    setTerms(sorted);
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort className="ml-1" />;
    return sortConfig.direction === 'asc'
      ? <FaSortUp className="ml-1" />
      : <FaSortDown className="ml-1" />;
  };

  const handleView = (term) => { setSelectedTerm(term); setShowView(true); };
  const handleEdit = (term) => { setSelectedTerm(term); setIsEdit(true); setShowForm(true); };
  const handleCreate = () => { setSelectedTerm(null); setIsEdit(false); setShowForm(true); };

  // const handleDelete = async (term) => {
  //   if (!window.confirm(`Delete Payment Term: ${term.Code}?`)) return;
  //   try {
  //     const res = await fetch(`${API_URL}/payment-terms/${term.Code}`, { method: 'DELETE' });
  //     if (!res.ok) throw new Error("Delete failed");
  //     fetchTerms();
  //   } catch (err) {
  //     alert(err.message);
  //   }
  // };

  const handleFormSubmit = () => { setShowForm(false); fetchTerms(); };

  return (
  <div className="min-h-screen flex bg-[#E5E1DA]">
    {/* Sidebar hidden on small screens */}
    
      <Sidebar />
    

    <main className="flex-1 p-2 sm:p-2 md:p-8 overflow-y-auto md:ml-16">
      <div className="flex flex-col h-full">
        
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-center sm:justify-between items-center text-center sm:items-center gap-3 mb-6">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#2b6777]">
            Payment Terms Master
          </h1>
          {/* <button
            className="flex items-center justify-center gap-2 bg-[#92C7CF] hover:bg-[#AAD7D9] text-white font-semibold px-3 sm:px-4 py-2 rounded-lg shadow text-sm sm:text-base"
            onClick={handleCreate}
          >
            <FaPlus className="text-sm sm:text-base" />
            <span className=" xs:inline">Create New Term</span>
          </button> */}
        </div>

        {/* Table wrapper */}
        <div className="overflow-x-auto">
          <table className="w-full bg-white rounded-xl shadow-lg min-w-[500px]">
            <thead>
              <tr>
                {["Code","DueDate","Description"].map((col)=>(
                  <th
                    key={col}
                    className="bg-[#AAD7D9] text-[#2b6777] px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm font-bold cursor-pointer hover:bg-[#92C7CF]"
                    onClick={() => handleSort(col)}
                  >
                    <div className="flex items-center justify-center gap-1">
                      {col} {getSortIcon(col)}
                    </div>
                  </th>
                ))}
                <th className="bg-[#AAD7D9] text-[#2b6777] px-3 sm:px-6 py-3 sm:py-4 text-center text-xs sm:text-sm font-bold">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={4} className="text-center py-6 text-[#AAD7D9] text-sm">
                    Loading...
                  </td>
                </tr>
              ) : terms.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center py-6 text-[#AAD7D9] text-sm">
                    No records found.
                  </td>
                </tr>
              ) : terms.map(term=>(
                <tr key={term.Code} className="hover:bg-[#eaf6f6] border-b">
                  <td className="px-3 sm:px-6 py-3 text-center text-xs sm:text-sm">{term.Code}</td>
                  <td className="px-3 sm:px-6 py-3 text-center text-xs sm:text-sm">{term.DueDate || '-'}</td>
                  <td className="px-3 sm:px-6 py-3 text-center text-xs sm:text-sm">{term.Description}</td>
                  <td className="px-3 sm:px-6 py-3 flex gap-2 justify-center">
                    <button onClick={()=>handleView(term)} className="p-2 hover:bg-[#c8d8e4] rounded-full text-sm sm:text-base">
                      <FaEye/>
                    </button>
                    {/* <button onClick={()=>handleDelete(term)} className="p-2 hover:bg-red-200 rounded-full text-red-700 text-sm sm:text-base">
                      <FaTrash/>
                    </button> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Modals */}
        <PaymentTermsFormModal
          open={showForm}
          onClose={()=>setShowForm(false)}
          onSubmit={handleFormSubmit}
          initialData={selectedTerm}
          isEdit={isEdit}
        />
        <PaymentTermsViewModal
          open={showView}
          onClose={()=>setShowView(false)}
          term={selectedTerm}
        />
      </div>
    </main>
  </div>
);

};

export default PaymentTermsMaster;
